$(document).ready(function () {

    // owlCarousel výpis nemovitostí
    window.nemovitostiOwlCarusel = function () {

        var $carusel = $('.nemovitosti-foto.JS-owl-carousel:not(.owl-carousel)');

        if ($carusel.length === 0)
            return;

        $carusel.owlCarousel({
            singleItem: true,
            navigation: true,
            navigationText: false,
            lazyLoad: true,
            pagination: false,
        });
    };
    window.nemovitostiOwlCarusel();

    // owlCarousel detail aktuality
    (function () {
        var $carusel = $('.JS-owlCarousel');
        if ($carusel.length === 0)
            return;
        $carusel.owlCarousel({
            navigation: true,
            navigationText: false,
            lazyLoad: true,
            pagination: false,
            itemsScaleUp: true,
            navigationText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
        });
    }());

    // owlCarousel kontakty-pobočky
    (function () {
        var $carusel = $('.JS-owlCarousel-kontakty-fotogalerie');
        if ($carusel.length === 0)
            return;
        $carusel.owlCarousel({
            navigation: true,
            navigationText: false,
            lazyLoad: true,
            pagination: true,
            itemsScaleUp: true,
            items: 3,
        });
    }());

    // owlCarousel - slider nabídek na HP
    (function() {
        var $carusel = $('.JS-index-slider-owl');
        if ($carusel.length === 0)
            return;
        $carusel.owlCarousel({
            navigation: true,
            navigationText: false,
            lazyLoad: true,
            pagination: false,
            itemsScaleUp: true,
            singleItem: true,
            navigationText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
        });
    }());

    // owlCarousel - slider v detailu nemovitosti (detail-3)
    window.nemovitost3OwlCarusel = function() {

        var $carusel = $('.JS-detail-3-photo-slider');

        if ($carusel.length === 0)
            return;

        $carusel.owlCarousel({
            items: 4,
            navigation: true,
            navigationText: false,
            lazyLoad: true,
            pagination: false,
            itemsScaleUp: true
        });
    };
    window.nemovitost3OwlCarusel();

    // owlCarousel inzertní portály
    (function() {
        var $carusel = $('.JS-footer-inzerce');

        if ($carusel.length === 0)
            return;

        $carusel.owlCarousel({
            navigation: false,
            pagination: false,
            lazyLoad: true,
            pagination: false,
            autoPlay : true,
            stopOnHover : true,
            itemsScaleUp: true
        });
    }());


    // výpis projektů | owlCarousel
    (function() {
        var $carusel = $('.JS-owl-carousel-projekty');
        if ($carusel.length === 0)
            return;
        $($carusel).owlCarousel({
            navigation: true,
            navigationText: false,
            lazyLoad: window.setting.lazy_images,
            items: 5,
            itemsScaleUp: true,
            pagination: false
        });
    }());
});